export class NpsSurveyQuestionDto {
  id?: number;
  npsSurveyId: number;
  pieCategory: string;
  sequence: number;
  content: string;
  createdDate?: Date;
  modifiedDate?: Date;
}
